import { render, staticRenderFns } from "./JImageUpload.vue?vue&type=template&id=15daafde&scoped=true"
import script from "./JImageUpload.vue?vue&type=script&lang=js"
export * from "./JImageUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15daafde",
  null
  
)

export default component.exports